"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Cell = _interopRequireDefault(require("./Cell"));
var Row = function Row(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("tr", null, _react["default"].Children.map(children, function (el) {
    var elementType = el.type.target || el.type;
    if (elementType === _Cell["default"]) return el;
    return /*#__PURE__*/_react["default"].createElement("td", null, el);
  }));
};
Row.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = Row;